import { containerCss, folderPathCss, locationCss } from "./index.styles";

import { GroupLabelIcon } from "~/client/components/GroupsLabel";
import { KibelaSymbol } from "~/client/components/shared/kibela_symbol";
import type { Group } from "~/client/generated/schema";

interface Props {
  group: Partial<Group>;
  folderPath: string | null;
}
export const LocationSearchFilterDescription: React.FC<Props> = ({ group, folderPath }) => {
  return (
    <div css={containerCss}>
      <div css={locationCss}>
        {group.isPrivate !== undefined && (
          <span className="group-icon-wrapper">
            <GroupLabelIcon isPrivate={group.isPrivate} />
          </span>
        )}
        <span>{group.name}</span>
        {folderPath && " / "}
        {folderPath && (
          <div css={folderPathCss}>
            <span className="folder-icon-wrapper">
              <KibelaSymbol id="folder" />
            </span>
            <span>{folderPath}</span>
          </div>
        )}
      </div>
    </div>
  );
};
